module.exports = __webpack_public_path__ + "img/n1.d4100468.png";